module.exports = __webpack_public_path__ + "img/A61-20190408_07.b581d7e4.jpg";